var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header header-ct" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header-main" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.clientSelected,
                expression: "clientSelected"
              }
            ],
            staticClass: "selected-client-ct"
          },
          [
            _vm.isAuthenticated && _vm.displayClientMsg
              ? _c(
                  "b-link",
                  {
                    staticClass: "italic link-blue",
                    on: { click: _vm.navigateToClientSelection }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.clientSaved.text
                            ? _vm.clientSaved.text
                            : "Please select a Publisher"
                        ) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.isAuthenticated
          ? _c(
              "b-dropdown",
              {
                staticClass:
                  "user-drop-btn d-flex align-items-center justify-content-between",
                attrs: { id: "ddown-divider", variant: "primary" }
              },
              [
                _c("template", { slot: "button-content" }, [
                  _c("i", {
                    staticClass: "fas fa-user fa-lg spacer-left user-icon"
                  }),
                  _c("span", { staticClass: "user-name ml-2" }, [
                    _vm._v(_vm._s(_vm.userEmail))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    staticClass: "user-drop-btn logout-btn",
                    on: { click: _vm.onSignoutPressed }
                  },
                  [_vm._v("\n        Logout\n      ")]
                )
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-container" }, [
      _c("img", {
        staticClass: "my-auto",
        attrs: { src: "/static/images/cds-logo.png", alt: "CDS Global" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }